import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ClipStatus } from "@air/types";
import { clearThumbnailCache, ClipUtils } from "@air/utils-clips";
import { memo, Suspense, useMemo } from "react";
import { useSelector } from "react-redux";
import { ClipPreview } from "~/components/Shared/ClipList/ClipItem/ClipPreview";
import { GalleryAssetThumbnailImage } from "~/components/v2/components/shared/gallery/GalleryAssetThumbnailImage";
import { getPreferenceClassName, getPreferenceImgixFit, useThumbnailPreference } from "~/hooks/useThumbnailPreference";
import { CentralizedBoardSelectors } from "~/store/centralizedBoard/selectors";
export const GalleryAssetThumbnail = /*#__PURE__*/ memo((param)=>{
    let { clip, isHovering, width, height } = param;
    const videoSrc = clip.assets.previewVideo;
    var _clip_duration;
    const playbackRate = ClipUtils.determinePlaybackRate((_clip_duration = clip.duration) !== null && _clip_duration !== void 0 ? _clip_duration : 0, videoSrc !== null && videoSrc !== void 0 ? videoSrc : "");
    const vertical = clip.status === ClipStatus.transcoded && !ClipUtils.isLandscape(clip.rotation);
    const { getPreference } = useThumbnailPreference();
    const boardId = useSelector(CentralizedBoardSelectors.boardId);
    const thumbnailPreference = useMemo(()=>getPreference(boardId), [
        boardId,
        getPreference
    ]);
    const CardThumbnail = useMemo(()=>/*#__PURE__*/ _jsx(GalleryAssetThumbnailImage, {
            ...clip,
            className: getPreferenceClassName(thumbnailPreference),
            animatedSrc: clip.type === "animated" && isHovering && videoSrc ? videoSrc : "",
            imgixParams: {
                fit: getPreferenceImgixFit(thumbnailPreference)
            },
            src: clearThumbnailCache({
                clipExt: clip.ext,
                clipStatus: clip.status,
                imageSrc: clip.assets.image,
                clipUpdatedAt: clip.updatedAt
            }),
            width: width,
            height: height
        }), [
        clip,
        isHovering,
        videoSrc,
        thumbnailPreference,
        width,
        height
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            CardThumbnail,
            !!videoSrc && clip.type === "video" && !ClipUtils.isProcessing(clip.status) && isHovering && /*#__PURE__*/ _jsx(Suspense, {
                fallback: CardThumbnail,
                children: /*#__PURE__*/ _jsx(ClipPreview, {
                    vertical: vertical,
                    playbackRate: playbackRate,
                    status: clip.status,
                    src: videoSrc
                })
            })
        ]
    });
});
GalleryAssetThumbnail.displayName = "GalleryAssetThumbnail";
